 <!--The content below is only a placeholder and can be replaced. -->
 <div *ngIf="showLoader" id="configurationLoader" class="config-loaded">
   Loading Configuration.....
 </div>
 <div id="WaitCursorDiv" class="cursor-waiting">
 </div>
 <ngx-ui-loader></ngx-ui-loader>

 <app-top-menu *ngIf="success"></app-top-menu>

 <div *ngIf="success" class="row k-flex-grow flex-column-sm">
   <div class="col-md-3 col-sm-12 menu-container"
        [class.collapsed]="menuCollapsed"
        [hidden]="notIsLoggedIn">
     <app-left-menu #leftMenu
                    (collapseChanged)="collapseMenu($event)"
                    (openFaq)="changeFAQState()"
     ></app-left-menu>
   </div>
   <div [ngClass]="notIsLoggedIn ?'col-sm-12' : 'col-md-9 col-sm-12'"
        class="main-container"
        [class.collapsed]="menuCollapsed">
     <div class="outlet-wrapper">
       <router-outlet></router-outlet>
     </div>
   </div>
   <div class="faq-container" [class.closed]="notIsLoggedIn || isFaqHidden">
     <app-faq (close)="isFaqHidden = true"></app-faq>
   </div>
 </div>

 <app-pop-up-dialog [Message]="alertMessage" [Display]="display" (DisplayBack)="onConfirm()">
 </app-pop-up-dialog>
